import { useQuery } from "@tanstack/react-query";
import {
  getProductStatsRequest,
  getStatsActivityOrdersRequest,
  getStatsAssetCustomerRequest,
  getStatsAssetProcessorRequest,
  getStatsAssetStatusRequest,
  getStatsOrdersOveriewCurrentRequest,
  getStatsOrdersOverviewTodayRequest,
  getStatsOrdersUnreconciledRequest,
} from "../requests/stats";

export function useProductStatsTag({ productId, params }) {
  return useQuery({
    queryKey: [`stats/product/${productId}/tags`, params],
    queryFn: async () => {
      const res = await getProductStatsRequest({
        productId,
        params,
      });
      return res.data?.data;
    },
  });
}

export function useStatsActivityOrders({ params }) {
  return useQuery({
    queryKey: [`stats/activity/orders`, params],
    queryFn: async () => {
      const res = await getStatsActivityOrdersRequest({
        params,
      });
      return res.data?.data;
    },
  });
}

export function useStatsAssetStatus({ params } = {}) {
  return useQuery({
    queryKey: [`/v1/stats/asset/status`, params],
    queryFn: async () => {
      const res = await getStatsAssetStatusRequest({
        params,
      });
      return res.data?.data;
    },
  });
}

export function useStatsAssetCustomer({ params } = {}) {
  return useQuery({
    queryKey: [`/v1/stats/asset/customer`, params],
    queryFn: async () => {
      const res = await getStatsAssetCustomerRequest({
        params,
      });
      return res.data?.data;
    },
  });
}

export function useStatsAssetProcessor({ params } = {}) {
  return useQuery({
    queryKey: [`/v1/stats/asset/processor`, params],
    queryFn: async () => {
      const res = await getStatsAssetProcessorRequest({
        params,
      });
      return res.data?.data;
    },
  });
}

export function useStatsOrdersOverviewToday({ params } = {}) {
  return useQuery({
    queryKey: [`stats/orders/overview/today`, params],
    queryFn: async () => {
      const res = await getStatsOrdersOverviewTodayRequest({
        params,
      });
      return res.data?.data;
    },
  });
}

export function useStatsOrdersOverviewCurrent({ params } = {}) {
  return useQuery({
    queryKey: [`stats/orders/overview/current`, params],
    queryFn: async () => {
      const res = await getStatsOrdersOveriewCurrentRequest({
        params,
      });
      return res.data?.data;
    },
  });
}

export function useStatsOrdersUnreconciled({ params } = {}) {
  return useQuery({
    queryKey: [`stats/orders/unreconciled`, params],
    queryFn: async () => {
      const res = await getStatsOrdersUnreconciledRequest({
        params,
      });
      return res.data?.data;
    },
  });
}
